export const toTokens = (amount: number) => {
    if (!amount) return ''
    const tokens = amount === 1 ? 'token' : 'tokens'
    return `${amount} ${tokens}`
}
